import React, {Component} from "react";

import Layer1 from "../layers/Layer1"
import Layer2 from "../layers/Layer2"
import BuildingList from "../layers/Layer3/BuildingList"
import Layer4 from "../layers/Layer4"
import { useParams } from 'react-router-dom'
import useGlobal from "../store";

import "./index.scss";

const BuildingResults = () => {
    let [currentState, currentActions] = useGlobal();
    const { location } = useParams()

    const search = window.location.search;
    const queryParams = new URLSearchParams(search);
    const siteId = queryParams.get('site_id');

    return  (
        <div className="ui-main location">
            <Layer1 />
            <Layer2 context="Building" />
            <BuildingList location={location} siteId={siteId} />
            <Layer4 />
        </div>
    )
}

export default BuildingResults